import { Component, OnInit } from '@angular/core';
import { FieldArrayType, FormlyFormBuilder, FormlyFormOptions, FormlyFieldConfig, FormlyTemplateOptions } from '@ngx-formly/core';
import { FormGroup } from '@angular/forms';
import clone from 'lodash.clonedeep';

@Component({
    selector: 'formly-repeat-type',
    templateUrl: 'repeat.type.html'
})
export class RepeatTypeComponent extends FieldArrayType implements OnInit {
    showForm = false;
    singleForm = new FormGroup({});
    singleField = [];
    ops: any = {};
    mdl = {};

    constructor(builder: FormlyFormBuilder) {
        super(builder);
    }

    ngOnInit() {
        this.singleField = clone(this.field.fieldArray.fieldGroup);
    }

    addItem(value) {
        this.showForm = true;
    }

    hideForm() {
        this.showForm = false;
        this.ops.resetModel();
    }

    save(model) {
        this.add(null, model);
        this.hideForm();
    }
}
